import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { is, STATUS, toTag, restrictedLevel, isRestricted, roleOptions, ROLE } from '../admin/events/Constants';
import { connect } from 'react-redux';
import * as bookinActions from '../booking/redux/actions';
import { Icon, Col, Row, Spin, Button, Divider, Tag, Tooltip, Carousel } from 'antd';
import moment from 'moment';
import { IMAGES_URL } from '../../helper/api/Api';
import Map from '../../helper/map/map';
import { Location } from '../../helper/map/Constants';
import RichTextEditor from 'react-rte';
import _ from 'lodash';

export class ItemDescription extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  static defaultProps = {
    loading: false,
  }

  handleSubcribe(subcribed) {

    if (this.props.id || this.props.match.params.id)
      if (!subcribed) {
        this.props.actions.addBooking(this.props.id || this.props.match.params.id)
      }
      else {
        this.props.actions.deleteBooking(this.props.id || this.props.match.params.id)
      }
  }

  render() {
    if (this.props.loading) return (
      <Row type="flex" className="ant-modal-body">
        <Spin style={{
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto'
        }} />
      </Row>
    )

    const description = this.props.item.event.description || '';
    const openAt = moment(this.props.item.event.openAt);
    const closeAt = moment(this.props.item.event.closeAt);
    const startAt = moment(this.props.item.event.startAt);
    const endAt = moment(this.props.item.event.endAt);
    const restricted = restrictedLevel(this.props.item.event);

    return (
      <Row type="flex" className="ant-modal-body item-description-row">
        {
          this.props.is.admin ?
            <Row type="flex" style={{ position: 'absolute', right: '15px', flexDirection: 'column', top: '60px', zIndex: '10' }}>
              <Link to={'/admin/events/update/' + (this.props.id || this.props.match.params.id)} style={{ margin: 10 }}>
                <Tooltip placement="left" title="Edition">
                  <Button shape="circle" type="default" icon="edit" />
                </Tooltip>
              </Link>
              <Link to={'/admin/events/registration/' + (this.props.id || this.props.match.params.id)} style={{ margin: 10 }} target="_blank">
                <Tooltip placement="left" title="Valider les inscriptions">
                  <Button shape="circle" type="primary" icon="bars" />
                </Tooltip>
              </Link>
            </Row>
            : ''
        }
        {
          this.props.item.event.moderators.filter(m => m.user.email === this.props.email).length > 0 ?
            <Row type="flex" style={{ position: 'absolute', right: '15px', flexDirection: 'column', top: '60px', zIndex: '10' }}>
              <Link to={'/admin/events/presence/' + (this.props.id || this.props.match.params.id)} style={{ margin: 10 }}>
                <Tooltip placement="left" title="Présences">
                  <Button shape="circle" type="primary" icon="check" />
                </Tooltip>
              </Link>
            </Row>
            : ''
        }
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} className="content-left">
          {this.props.item.event.images && this.props.item.event.images.length !== 0 ?
            <Carousel autoplay vertical className="slider-item-description">
              {this.props.item.event.images.map(image => <div><img className="img-slider-event" style={{ backgroundImage: 'url("' + IMAGES_URL(image.url) + '") ' }} /></div>)}
            </Carousel>
            :
            <Carousel autoplay vertical className="slider-item-description">
              <div><img className="img-slider-event" style={{ backgroundImage: 'url("' + IMAGES_URL() + '") ' }} /></div>
            </Carousel>
          }
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }} className="content-right">

          {/* Alert restricted */}
          {
            isRestricted(this.props.item.event) &&
            <div>
              <Tooltip placement="bottom" title={restricted.name}>
                <div className="ribbon-wrapper-item">
                  <div className={"ribbon-item " + restricted.class}>{restricted.title}</div>
                </div>
              </Tooltip>
              {this.props.is.admin
                || (restricted.role === ROLE.STUDENT && (this.props.is.ynov))
                || (restricted.role === ROLE.FOREIGNER && this.props.is.auth && !this.props.is.ynov) ? '' :
                <div className={"alert-restricted " + restricted.class}>
                  <div className="left-content">
                    <Icon type="stop" theme="outlined" />
                  </div>
                  {restricted.name}
                </div>
              }
            </div>
          }

          <Col xs={{ span: 24 }}>
            <div>
              <p className="day">{openAt.format('DD')}</p>
              <p className="mounth-years">{openAt.format('MMMM')} {openAt.format('YYYY')}</p>
              {openAt.format('DD MMMM YYYY') === closeAt.format('DD MMMM YYYY') ?
                <p></p>
                :
                <p>Jusqu'au <strong>{closeAt.format('DD MMMM YYYY')}</strong></p>
              }
            </div>
            <div>
              {
                this.props.item.event.eventCategory.length === 0 ? '' :
                  this.props.item.event.eventCategory.map((c, index) => {
                    if (this.props.categories)
                      c = { category: { name: this.props.categories.filter(f => f.id === c)[0].name } }

                    return (<Tag key={index} color="#1d1d1b">{c.category.name}</Tag>)
                  })
              }
            </div>
            <h1 className="title">{this.props.item.event.title} </h1>
            <div className="hours">
              <Icon type="clock-circle-o" style={{ fontSize: 18, marginRight: '10px', marginTop: '6px', float: 'left' }} />
              {openAt.isSame(closeAt, 'day') ?
                <p style={{ fontSize: 20 }}>{openAt.format("HH:mm")} - {closeAt.format("HH:mm")}</p>
                :
                <p style={{ fontSize: 20 }}>{openAt.format("DD MMM")} à {openAt.format("HH:mm")} - {closeAt.format("DD MMM")} à {closeAt.format("HH:mm")}</p>
              }
            </div>
            <p className="description">
              <RichTextEditor
                  value={RichTextEditor.createValueFromString(description || null, 'html')}
                  style={{border: "none"}}
                  readOnly
                  />
            </p>
            <Divider dashed />
            <Row>
              <h1 className="title-inscription"> INSCRIPTION <Tag color={toTag(is(this.props.item.event, true)).color}>{toTag(is(this.props.item.event, true)).text}</Tag> </h1>
              {this.props.item.event.subscribeNumber === 0 ? "" :
                <Row>
                  <p style={{ display: 'flex' }}>
                    <Icon type="user" style={{ fontSize: 24, marginRight: '10px' }} /> Places : {this.props.item.event.subscribeNumber}

                    {this.props.item.event.subscribeNumber !== 0 && ![STATUS.ONGOING, STATUS.FREE].includes(is(this.props.item.event, true)) ? '' :
                      <Tag style={{ marginLeft: 10 }} color="cyan">{this.props.item.event.subscribeNumber - this.props.item.event.subscribedNumber} disponibles</Tag>
                    }
                  </p>
                </Row>
              }
              <Row>
                {
                  [STATUS.FREE, STATUS.FULL_FREE].includes(is(this.props.item.event, true)) ?
                    ''//<Tag color={toTag(is(this.props.item.event, true)).color}>{toTag(is(this.props.item.event, true)).text}</Tag>
                    :
                    <p style={{ display: 'flex' }} >
                      <Icon type="profile" style={{ fontSize: 24, marginRight: '10px' }} /> Dates d'inscription : {startAt.format('ll') + " - " + endAt.format("ll")}
                    </p>
                }

              </Row>
              <Row>
                <p style={{ display: 'flex' }}>
                  <Icon type="euro" theme="outlined" style={{ fontSize: 24, marginRight: '10px' }}/> 
                  {this.props.item.price && this.props.item.price.amount ? this.props.item.price.amount + ' €' : "GRATUIT"}
                  {/*this.props.item.event.prices && this.props.item.event.prices.length > 1 ? 
                    <div style={{ display: 'flex', flexDirection: 'column', borderLeft: 'grey 1px solid', padding: '2px 20px', 'marginLeft': 20 }}>
                      {
                        _.orderBy(this.props.item.event.prices, ['amount'], ['desc'])
                          .filter((p) => [ROLE.STUDENT, ROLE.FOREIGNER].includes(p.role.name) || (p.role.name === ROLE.MODERATOR && (this.props.is.moderator || this.props.is.admin)) || (p.role.name === ROLE.ADMIN && this.props.is.admin))  
                          .map((p) => <div>{ _.find(roleOptions(ROLE), (item) => p.role.name === item.id).name } - {p.amount} €</div>)
                      }
                    </div>
                    : ""*/}
                </p>
              </Row>
              {
                this.props.item.event.juryPoint ?
                  <Row>
                    <p style={{ display: 'flex' }}>
                      <Icon type="star-o" style={{ fontSize: 24, marginRight: '10px' }} />
                      <Tag color="green">{this.props.item.event.juryPoint} Points Jury</Tag>
                    </p>
                  </Row>
                  :
                  ''
              }
              {is(this.props.item.event, true) === STATUS.FULL_FREE ? '' :

                (![STATUS.ONGOING, STATUS.FREE, STATUS.COMING, STATUS.FULL].includes(is(this.props.item.event, true))) ?
                  <Row style={{ marginBottom: '30px' }}>
                    <div className="btn-event-done">
                      <Icon type="close-circle-o" />
                      Inscriptions terminées
                    </div>
                  </Row>
                  :
                  <Row style={{ marginBottom: '30px' }}>
                    <Button
                      disabled={ (
                        this.props.booking.status.addBooking.pending
                        || this.props.booking.status.deleteBooking.pending
                        || is(this.props.item.event, true) === STATUS.COMING
                        || (isRestricted(this.props.item.event) && !this.props.item.event.restrictedRoles.some(r => this.props.auth.user.pk_user.includes(r.role.name)))
                      )}
                      loading={this.props.booking.status.addBooking.pending || this.props.booking.status.deleteBooking.pending}
                      type={ this.props.item.booked ? "default" : "primary"}
                      icon={ this.props.item.booked ? "close" : "plus" }
                      onClick={() => this.handleSubcribe(this.props.item.booked)} className="ui-btn btn-booking">
                      {this.props.item.booked ? "Annuler ma réservation" : "s'inscrire à cet événement"}
                    </Button>
                  </Row>
              }
            </Row>
            <Row>
              {
                  this.props.item.event.location ?
                <Col xs={{ span: 24 }} style={{ height: 200 }}>
                    <Map
                      location={this.props.item.event.location}
                    />
                </Col>
                : ''
              }
              <Col xs={{ span: 24 }}>
                {
                  this.props.item.event.location ?
                    <Col xs={{ span: 24 }}>
                      <p style={{ display: 'flex', marginTop: 20 }}>
                        <Icon type="environment-o" style={{ fontSize: 24, marginRight: '10px' }} /> {Location.parse(this.props.item.event.location).address}
                      </p>
                    </Col> : ''
                }
              </Col>
            </Row>
            <Row className="hidden">
              <h2>{this.props.item.event.title}</h2>
              <p>{openAt.isSame(closeAt, 'day') ?
                openAt.format("HH:mm") + ' - ' + closeAt.format("HH:mm")
                :
                openAt.format("DD MMMM") + ' à ' + openAt.format("HH:mm") + ' - ' + closeAt.format("DD MMM") + ' à ' + closeAt.format("HH:mm")
              }
              </p>
              <p>{description || null}</p>
              <ul>
                <li>places : {this.props.item.event.subscribeNumber}</li>
                <li>Dates d'inscription : {startAt.format('ll') + " - " + endAt.format("ll")}</li>
                <li>Prix : {this.props.item.price && this.props.item.price.amount ? this.props.item.price.amount + ' €' : "GRATUIT"}</li>
              </ul>
            </Row>
            <Divider dashed />
          </Col>
        </Col>
      </Row>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    is: {
      ynov: state.authentification.isYnov,
      auth: state.authentification.isAuth,
      admin: state.authentification.isAdmin,
      moderator: state.authentification.isModerator
    },
    auth: state.authentification,
    email: state.authentification.user.email,
    booking: state.booking
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...bookinActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemDescription);



// WEBPACK FOOTER //
// ./src/features/event/ItemDescription.js